import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Portfolio from "./pages/Portfolio";
import Blogs from "./pages/Blogs";
import Contact from "./pages/Contact";
import Login from "./admin/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoutes from "./admin/AdminRoutes";
import NotFound from "./pages/NotFound";
import ScrollToTop from "./components/ScrollToTop";
import WhatsAppButton from "./components/WhatsAppButton";

// ✅ Public Layout (Navbar + Footer)
function PublicLayout() {
  return (
    <>
      <Navbar />
      <main className="pt-[75px]">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton /> 
    </>
  );
}

export default function App() {
  return (
    <Router>
        <ScrollToTop/>
      <Routes>
        {/* ✅ Public Website Pages */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/contact" element={<Contact />} />
        </Route>

        {/* ✅ Admin Login (NO Navbar/Footer) */}
        <Route path="/admin/login" element={<Login />} />

        {/* ✅ Protected Admin Dashboard */}
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute>
              <AdminRoutes />
            </ProtectedRoute>
          }
        />

        {/* ✅ 404 Catch-all */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}